import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@storable/canaveral-components';
import { Form } from 'react-bootstrap';
import Button from '../../components/stateless/Button';
import FacilitiesMapEditorPrimaryFacility from '../../../../website/containers/FacilitiesMapEditorPrimaryFacility';
import FacilitiesMapEditor from '../../../../website/components/stateful/FacilitiesMapEditor/FacilitiesMapEditor';
import styles from './styles.scss';

const propTypes = {
  center: PropTypes.shape({
    longitude: PropTypes.string,
    latitude: PropTypes.string,
  }),
  facilities: PropTypes.array.isRequired,
  facilityId: PropTypes.string,
  onCancelEdit: PropTypes.function.isRequired,
  onFinishEdit: PropTypes.function.isRequired,
  primaryFacilityId: PropTypes.string,
  zoom: PropTypes.string,
  enableClustering: PropTypes.bool,
  clusterRadius: PropTypes.number,
  multiFacility: PropTypes.bool,
};

const defaultProps = {
  center: undefined,
  facilityId: undefined,
  primaryFacilityId: undefined,
  zoom: undefined,
  enableClustering: false,
  clusterRadius: 40,
  multiFacility: false, // If It is for MultiFacility of Single Facility
};

const Editor = ({
  facilities,
  facilityId,
  primaryFacilityId,
  onCancelEdit,
  onFinishEdit,
  zoom: zoomFromProps,
  center: centerFromProps,
  enableClustering: enableClusteringFromProps,
  clusterRadius: clusterRadiusFromProps,
  colors: colorsFromProps,
  mapStyle: mapStyleFromProps,
  multiFacility,
  ...rest
}) => {
  const [zoom, setZoom] = useState(zoomFromProps);
  const [center, setCenter] = useState(centerFromProps);
  const [cluster, setCluster] = useState(enableClusteringFromProps || false);
  const [clusterRadius, setClusterRadius] = useState(clusterRadiusFromProps);
  const [colors, setColors] = useState(
    colorsFromProps || {
      pin: 'primary',
      cluster: 'secondary',
    },
  );
  const [mapStyle, setMapStyle] = useState(
    mapStyleFromProps || 'mapbox://styles/mapbox/streets-v12',
  );
  const handleSave = () => onFinishEdit({
    center,
    zoom,
    facilityId,
    enableClustering: cluster,
    clusterRadius,
    colors,
    mapStyle,
  });

  return (
    <Modal
      show
      onDismiss={onCancelEdit}
      aria-labelledby="mapbox-editor"
      size="lg"
    >
      <Modal.Header>
        <Modal.Title id="map-editor">Map Display</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={styles.title}>
          Adjust the zoom level and positioning of your map.
        </div>
        {multiFacility && (
          <Form.Text>
          If this widget is placed on a facility page, the facility’s
          address will be marked with a special pin.
          </Form.Text>
        )}
        <FacilitiesMapEditorPrimaryFacility
          primaryFacilityId={primaryFacilityId}
          facilities={facilities}
        >
          {foundFacilities => (
            <FacilitiesMapEditor
              {...rest}
              multiFacility={multiFacility}
              facilities={foundFacilities}
              primaryFacilityId={primaryFacilityId}
              onZoom={setZoom}
              onPan={setCenter}
              onClusterRadiusChange={setClusterRadius}
              colors={colors}
              onColorsChange={setColors}
              onClusterToggle={setCluster}
              onMapStyleUpdate={setMapStyle}
              mapStyle={mapStyle}
              clusterRadius={clusterRadius}
              enableClustering={cluster}
              initialZoom={zoomFromProps}
              initialCenter={centerFromProps}
            />
          )}
        </FacilitiesMapEditorPrimaryFacility>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onCancelEdit} variant="default">Cancel</Button>
        <Button onClick={handleSave} variant="success">Save</Button>
      </Modal.Footer>
    </Modal>
  );
};

Editor.propTypes = propTypes;
Editor.defaultProps = defaultProps;

export default Editor;
